import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { CharacterStandingsEntity } from ".";
import { HandleEsiError } from "../helpers/ErrorDisplayHelper";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedCharacterStandingsEntity(
  character_id: number,
  token: string,
  show_agents: boolean
): Promise<CharacterStandingsEntity | null> {
  let entity: any = await cache.get(character_id);
  if (entity) {
    return entity;
  }
  try {
    const standings = await esiClient.get_characters_character_id_standings(character_id, null, null, token);
    if (standings !== null) {
      entity = new CharacterStandingsEntity(character_id, standings, show_agents);
      cache.put(character_id, entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    HandleEsiError(error, character_id, "character_standings");
    return null;
  }
}
